// Imports
import thunkMiddleware, { ThunkMiddleware } from 'redux-thunk';
import { createStore, applyMiddleware, AnyAction } from 'redux';
import rootReducer from '../../../../redux/reducer';


// Type the Thunk middleware to get correct type inferences in the store
const typedThunkMiddleware: ThunkMiddleware<ReturnType<typeof rootReducer>, AnyAction> = thunkMiddleware;


// Create a new store instance
export function createReduxStore() {
	return createStore(rootReducer, applyMiddleware(typedThunkMiddleware));
}


// Create store
const store = createReduxStore();


// Export
export default store;
